export default {
  props: {
    leftTitle: {
      type: String
    },
    leftIconImg: {
      type: String
    },
    placeholder: {
      type: String
    }
  }
};